<template>
  <div class="authBackground">
    <div class="logoMain">
      <img class="logoImg" src="~assets/img/home/img_login_photo.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "authBackground",
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.authBackground {
  position: relative;
  width: 100%;
  .logoMain {
    text-align: center;
    margin-top: 15%;
    margin-bottom: 15%;
    .logoImg {
      width: 100%;
      object-fit: cover;
      margin: auto;
    }
  }
}
</style>
